<template>
<div class="borderb flag-check" v-for="item in data">
	<div class="flex-container paddingh30 paddingt40 marginb20 pos-r overflow-h">
		<div class="flex-container left">
			<a data-reload="true" :href="item.clickUrl" class="border-round" style="width: 48px; height: 48px; overflow: hidden;" data-scp="counter.index">
				<img :src="item.logoImageUrl" alt="" onerror="this.src='//img1.tg-img.com/tgou2/img2/product/brand_logo_default.png'">
			</a>
			<a data-reload="true" :href="item.clickUrl" class="marginl20 flex1" data-scp="counter.index" >
				<div class="flex-container left">
					<div class="text-limit1 fs-16"
						 v-text="item.title"></div>
					<div class="badge red small radius marginl10" style="padding: 3px 4px;background-image: linear-gradient(90deg, #FF6D6A 0%, #FF48C3 100%);"
						 v-if="item.haveScene && showScene">VR专柜</div>
					<div class="badge orange small radius marginl10" style="padding: 3px 4px;"
						 v-if="item.sticky">推荐</div>
					
				</div>
				<!-- <div class="text-light fs-10 text-limit1"><i class="icon-map marginr10"></i><span>{{item.subTitle}}</span></div> -->
				<div class="text-dark fs-12 flex-container left margint20 lh-1">
					<i class="icon-locationfill marginr10 text-lighter"></i>
					<span v-text="item.subTitle"></span>
				</div>
			</a>
		</div>
		
		<div @click="guanzhu(item)" data-scp="guanzhu.0">
			<div class="badge pill black reverse subscribeList"
				 style="padding: 6px 9px;min-width: 60px;"
				 v-if="!item.attention">
				<i class="icon-index_cancel marginr10 fs-11"></i>订阅
			</div>
			<div v-else class="badge pill black reverse subscribeList"
				 style="padding: 6px 9px;min-width: 60px;">
				<i class="icon-check marginr10 fs-11"></i>已订阅
			</div>
		</div>
	</div>
	<div v-if="item.items.length">
		<a class="paddingh20 paddingb20 dis-b" :href="item.clickUrl" data-scp="counter.index">
			<div class="flex-container counterMess text-red fs-11" style="overflow: hidden" v-if="item.activityObj.title && item.activityObj.subTitle">
				<div class="paddingh20 pos-r">活动</div>
				<div class="flex1 pos-r flex-container paddingl30 paddingr50">
					
						<div class="" v-text="item.activityObj.title"></div>
						<div style="font-size: 9px;" v-text="item.activityObj.subTitle"></div>
				</div>
			</div>
		</a>
		<div class="paddingh20 paddingb20" style="overflow-x: scroll;">
			<cmui-list :col="3" :space="20">
				<cmui-list-item v-for="item in item.items.slice(0, 3)">
					<a :href="item.clickUrl" data-scp="cp.{{$index}}">
						<div class="ratio-container img-container">
							<img alt="" width="100%"
								 onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'"
								 :src="item.imageUrl">
						</div>
						<div class="text-darker fs-13 text-center margint10 text-limit1" style="min-height:14px">
							<strong v-text="item.title"></strong>
						</div>
						<div class="margint10" :class="(item.originalPrice && item.originalPrice !== item.price) ? 'flex-container' : 'text-center'">
							<span class="flex1 text-red fs-13 text-right marginh10"
								  v-text="'¥'+item.price"></span>
							<del class="flex1 text-light text-left fs-10 marginh10"
								 v-if="item.originalPrice && item.originalPrice !== item.price"
								 v-text="'¥'+item.originalPrice"></del>
						</div>
					</a>
				</cmui-list-item>
			</cmui-list>
			<!-- <div class="flex1 paddingh10" v-for="item in item.items.slice(0, 3)">
				<object>
					<a :href="item.clickUrl" data-scp="cp.{{$index}}">
						<div class="ratio-container img-container">
							<img alt="" width="100%"
								 onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'"
								 :src="item.imageUrl">
						</div>
						<div class="text-darker fs-13 text-center margint10 text-limit1" style="min-height:14px">
							<strong v-text="item.title"></strong>
						</div>
						<div class="flex-container margint10">
							<span class="flex1 text-red fs-13 text-right marginh10"
								  v-text="'¥'+item.price"></span>
							<del class="flex1 text-light text-left fs-10 marginh10"
								 v-if="item.originalPrice"
								 v-text="'¥'+item.originalPrice"></del>
						</div>
					</a>
				</object>
			</div> -->
		</div>


<!-- 		<div class="scroll-container paddingl30 margint20 flex-container vfull top left paddingb10">
			<div class="marginr20 border" v-for="inner in item.items" style="min-width: 102px;">
				<a :href="inner.clickUrl" data-scp="cp.{{$index}}"><div style="width:100px;height:100px;background-color:#f5f5f8;">
						<div class="img-container">
							<img :src="inner.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'" >
						</div>
					</div></a>
				<div class="text-center text-dark fs-10 text-limit1 margint10" style="width:100px;">{{inner.title}}</div>
				<div class="text-center text-red fs-12 lh-20 text-limit1 paddingb10">¥ <span>{{inner.price}}</span></div>
			</div>
			<div style="width:100px;" class="marginr20 pos-r">
				<div style="width:100px;height:100px;background-color:#f5f5f8;">
					<div class="img-container">
						<img :src="inner.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img2/dum/dum_dog.png'" >
					</div>
				</div>
				<div class="text-center text-dark fs-10 text-limit1 margint10" style="width:100px;"> </div>
				<div class="text-center text-red fs-12 lh-20 text-limit1 paddingb10"><span> </span></div>
				<a :href="item.clickUrl" class="pos-a top0 bottom0 left0 right0" style="margin: auto;" data-scp="counter.index"><div style="width:100px;height:100%;background-color:#f5f5f8;" class="flex-container flex-container-col center">
						<div class="text-red fs-14 borderb paddingb10">进 专 柜</div>
						<div class="text-light fs-10 paddingt10">into counter</div>
					</div></a>
			</div>
		</div> -->
	</div>
	<div class="paddingh20" v-else>
		<div class="bg-counter text-center flex-container-col center paddingv10">
			<p class="fs-11 lh-12 paddingh10" style="color:#ff7992">{{item.activityObj.description}}</p>
			<p class="fs-20 lh-20 marginv10 paddingh10" style="color:#ff7992">{{item.activityObj.title}}</p>
			<p class="fs-13 text-white pos-r bg-counterDate"><span>{{item.activityObj.subTitle}}</span></p>
		</div>
	</div>
</div>	
</template>
<style lang="scss">
	.text-pink {
		color: #cd60dd;
	}
	.flag .outer, .flag .inner {
		width: 100%;
		height: 27px;
	}
	.flag .outer {
		transform:skew(145deg,0deg);
		-ms-transform:skew(145deg,0deg); /* IE 9 */
		-moz-transform:skew(145deg,0deg); /* Firefox */
		-webkit-transform:skew(145deg,0deg); /* Safari and Chrome */
		-o-transform:skew(145deg,0deg); /* Opera */
		opacity: 0.65;
	}
	.flag .inner {
		transform:skew(36deg,0deg);
		-ms-transform:skew(36deg,0deg); /* IE 9 */
		-moz-transform:skew(36deg,0deg); /* Firefox */
		-webkit-transform:skew(36deg,0deg); /* Safari and Chrome */
		-o-transform:skew(36deg,0deg); /* Opera */
		opacity: 0.65;
	}
	.flag-check:nth-child(4n+1) .flag .flag-bg {
		background-color: #ff7a7b;
	}
	.flag-check:nth-child(4n+2) .flag .flag-bg {
		background-color: #64d59f;
	}
	.flag-check:nth-child(4n+3) .flag .flag-bg {
		background-color: #ffca74;
	}
	.flag-check:nth-child(4n) .flag .flag-bg {
		background-color: #abd1f5;
	}
	.bg-counter{
				background:url("//image1.51tiangou.com/tgou2/img2/store/bg-counter.png") no-repeat center;
				background-size:100% 100%;
				min-height: 100px;
	}
	.bg-counterDate{
		height: 18px;
		min-width: 170px;
		display:inline-block;
	}
	.bg-counterDate:after{
		position: absolute;
		content:'';
	    width: 100%;
		background: rgba(255,111,125,.34);
		top:0;
		left:0;
		right:0;
		bottom:0;
		z-index: 0;
		transform: skew(145deg,0deg);
	    -ms-transform: skew(145deg,0deg);
	    -moz-transform: skew(145deg,0deg);
	    -webkit-transform: skew(145deg,0deg);
	    -o-transform: skew(145deg,0deg);
	}
	.bg-counterDate:before{
		position: absolute;
		content:'';
	    width: 100%;
		background: rgba(255,111,125,.61);
		top:0;
		left:0;
		right:0;
		bottom:0;
		z-index: 0;
		transform: skew(36deg,0deg);
	    -ms-transform: skew(36deg,0deg);
	    -moz-transform: skew(36deg,0deg);
	    -webkit-transform: skew(36deg,0deg);
	    -o-transform: skew(36deg,0deg);
	}
	.bg-counterDate span{
		position: absolute;
		z-index: 1;
		top:0;
		left:0;
		right:0;
		bottom:0;
		line-height: 18px;
	}
	.trans {
	    transform: rotate(-45deg);
	    -ms-transform: rotate(-45deg);
	    -webkit-transform: rotate(-45deg);
	}
	.counterMess{background:#ffeded;line-height:20px}
	.counterMess>div:first-child:after,.counterMess>div:first-child:before{content:'';position:absolute;width:7px;height:7px;border-radius:4px;background:#fff}
	.counterMess>div:first-child:before{top:-4px;right:-4px}
	.counterMess>div:first-child:after{bottom:-4px;right:-4px}
	.counterMess>div:last-child:after{content:'';position:absolute;width:1px;height:10px;background:#fff;left:0;top:5px}
</style>
<script>
	import member from '../../api/member.js';
	export default{
		props:{
			data:Array,
			defaultEvent:{type:Boolean,default:true},
			showScene:{type:Boolean,default:false}//是否显示vr标识，默认不显示
		},
		methods:{
			guanzhu(counterBanner){
				var vm=this;
				if(this.defaultEvent){
					if(!_.get(counterBanner,'attention')){
	                    member.attention({
	                        data: {
	                            state: +!counterBanner.attention,
	                            counterId: counterBanner.counterId,
	                            storeId: maple.cookie('storeId')
	                        },
	                        success() {
	                            maple.notice(counterBanner.attention ? '取消成功' : '订阅成功', counterBanner.attention ? 'index_cancel' : 'index_success');
	                            counterBanner.attention = !counterBanner.attention;
	                            //批量处理相同的
	                            vm.data
	                            .filter(item=>item.counterId===counterBanner.counterId)
	                            .forEach(item=>item.attention=counterBanner.attention)
	                        }
	                    })
	            	}else{
	            		maple.pageIns.changePage('/counter/index.html?id='+counterBanner.counterId,{},true)
	            	}
				}else{
					this.$dispatch('guanzhu',this,counterBanner);
				}
			}
		}
	}
</script>